import React from "react";
import { Link } from "react-router-dom";

class PopularLinks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eventClassifiers: [],
            isLoggedIn: false,
            displayEvents: [],
            topEventClassifierId: 1,
            currentEventClassifier: null,
            isBodyVisible: true
        };
    }

    handleHeaderClick() {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "popular-links", eventAction: "click", eventLabel: "popularlinks-header" });
        this.setState({
            isBodyVisible: !this.state.isBodyVisible
        });
    }

    handleLinkClick(value, e) {
        const thisComponent = this;
        GBEglobal.logger.log({ hitType: "event", eventCategory: "popular-links", eventAction: "click", eventLabel: value });

        if (value === "racingresult") {
            e.preventDefault();
            window.open(GBEglobal.settings.homePageConfiguration.generic, "Complete Result", "width=520, height=505");
        }

        if (value === "footballstatistics") {
            e.preventDefault();
            const statisticsUrl = configurationSettings.baseUrl + "screens/stats.aspx?inRunning=false&touchlineId=" + GBEglobal.settings.touchlineStatistics.touchlineId;
            const modalConfig = {
                content: {
                    title: "Statistics",
                    iframeSrc: statisticsUrl
                }
            };
            thisComponent.props.onShowModal(modalConfig);
        }

        thisComponent.props.togglePanel("left-nav", false);
        //if (configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq") {
        //    thisComponent.props.togglePanel(false);
        //}
    }

    render() {
        const thisComponent = this;
        const className = this.state.isBodyVisible ? "widgetHeader" : "collapsed widgetHeader";
        const bodyVisibleStyle = this.state.isBodyVisible ? {} : { "display": "none" };
        const modeString = GBEglobal.mode === ModeTypes.Singles ? "/exchange/" : "/sportsbook/";

        const resources = {
            "footballStatistics": "Football Statistics",
            "racingReplays": "Racing Replays",
            "racingResult": "Racing Results",
            "nextHorseRace": "Next Horse Race",
            "mobile": "Mobile",
            "promotions": "Promotions",
            "cashOutLink": "Cash Out",
            "betfinder": "Bet Finder",
            "inPlay": "In-Play",
            "virtuals": "Virtuals"
        };

        function getEventClasses(eventClassifier) {
            return "sport_icon generic _" + eventClassifier.eventId;
        }
        function getLinkClasses(link) {
            return "sport_icon generic " + link.key;
        }

        function getLink(link) {
            var path = "";

            switch (link.key) {
                case "inplay":
                case "nexthorserace":
                    path = modeString + link.key;
                    break;

                case "cashoutlink":
                    path = modeString + "cashout";
                    break;

                case "promotions":
                case "mobile":
                    path = "/" + link.key;
                    break;
                case "virtuals":
                    if (thisComponent.props.isBlockedFromGames || GBEglobal.settings.virtualConfig === undefined) {
                        path = modeString;
                        break;
                    }
                    path = modeString + "virtual-sports-" + GBEglobal.settings.virtualConfig.virtuals;
                    break;
                case "footballstatistics":
                case "racingresult":
                    path = "";
                    break;
                default:
                    path = "#" + link.key;
                    break;
            }
            return path;
        }


        var sortedLinks = this.props.config.links.concat(this.props.config.events);

        //remove racing replays for now
        const racingResultsLink = sortedLinks.find((o) => o.key === "racingreplays");
        const racingResultsIndex = sortedLinks.indexOf(racingResultsLink);
        if (racingResultsIndex > -1) {
            sortedLinks.splice(racingResultsIndex, 1);
        }

        if (thisComponent.props.isBlockedFromGames) {
            const virtualEventLink = sortedLinks.find((o) => o.key === "virtuals");
            const virtualIndex = sortedLinks.indexOf(virtualEventLink);
            if (virtualIndex > -1) {
                sortedLinks.splice(virtualIndex, 1);
            }
            if (GBEglobal.settings.virtualConfig) {
                const virtualsIndex2 = sortedLinks.indexOf(sortedLinks.find((o) => parseInt(o.eventId, 10) === parseInt(GBEglobal.settings.virtualConfig.virtuals, 10)));
                if (this.props.isBlockedFromGames) {
                    if (virtualsIndex2 > -1) {
                        sortedLinks.splice(virtualsIndex2, 1);
                    }
                }
            }

            const casinoEventLink = sortedLinks.find((o) => o.key === "casino");
            const casinoIndex = sortedLinks.indexOf(casinoEventLink);
            if (casinoIndex > -1) {
                sortedLinks.splice(casinoIndex, 1);
            }
        }

        return (
            <div className="popularLinks widget">
                <span className={className} onClick={this.handleHeaderClick.bind(this)}><i className="arrow" />{GBEglobal.resources.PopularLinks}</span>
                <div style={bodyVisibleStyle}>
                    {sortedLinks.map((linkOrEvent, index) => {

                        if (linkOrEvent.eventId) {
                            //const eventClassifier = thisComponent.props.controller.getCachedEventClassifier(linkOrEvent.eventId);
                            //if (eventClassifier !== undefined) {
                            return (
                                <Link className="btn btn-default top a" key={index} to={GBEglobal.getEventClassifierPath(linkOrEvent.eventId)} onClick={this.handleLinkClick.bind(this, linkOrEvent.title.toLowerCase().replace(/\s/g, "-"))}>
                                    <i className={getEventClasses(linkOrEvent)}></i>
                                    {linkOrEvent.title}
                                </Link>
                            );
                            // }
                        } else {
                            return (
                                <Link className="btn btn-default top a" key={index} to={getLink(linkOrEvent)} onClick={this.handleLinkClick.bind(this, linkOrEvent.titleProp.toLowerCase().replace(/\s/g, "-"))}>
                                    <i className={getLinkClasses(linkOrEvent)}></i>
                                    {resources[linkOrEvent.titleProp] || linkOrEvent.titleProp}
                                </Link>
                            );
                        }

                    })}
                </div>

            </div>
        );
    }
}

export { PopularLinks };